import { ValidationErrorData } from '../typings/common';
import { TargetTagsEditorsState } from '../typings/state';
import { TargetPlatform } from '../typings/targetTagsEditor';

export const INIT_TARGET_TAGS_EDITORS = 'INIT_TARGET_TAGS_EDITORS';
export type INIT_TARGET_TAGS_EDITORS = typeof INIT_TARGET_TAGS_EDITORS;

export interface InitTargetTagsEditorsAction {
    type: INIT_TARGET_TAGS_EDITORS;
    editors: TargetTagsEditorsState;
}

export function initTargetTagsEditors(editors: TargetTagsEditorsState): InitTargetTagsEditorsAction {
    return {
        type: INIT_TARGET_TAGS_EDITORS,
        editors
    };
}

export const CHANGE_TARGET_PLATFORM = 'CHANGE_TARGET_PLATFORM';
export type CHANGE_TARGET_PLATFORM = typeof CHANGE_TARGET_PLATFORM;

export interface ChangeTargetPlatformAction {
    type: CHANGE_TARGET_PLATFORM;
    editorId: string;
    platform: TargetPlatform;
}

export function changeTargetPlatform(editorId: string, platform: TargetPlatform): ChangeTargetPlatformAction {
    return {
        type: CHANGE_TARGET_PLATFORM,
        editorId,
        platform
    };
}

export const UPDATE_TARGET_TAGS_EDITOR_VALIDATION = 'UPDATE_TARGET_TAGS_EDITOR_VALIDATION';
export type UPDATE_TARGET_TAGS_EDITOR_VALIDATION = typeof UPDATE_TARGET_TAGS_EDITOR_VALIDATION;

export interface UpdateTargetTagsEditorValidationAction {
    type: UPDATE_TARGET_TAGS_EDITOR_VALIDATION;
    editorId: string;
    errors: ValidationErrorData[];
}

export function updateTargetTagsEditorValidation(
    editorId: string,
    errors: ValidationErrorData[]
): UpdateTargetTagsEditorValidationAction {
    return {
        type: UPDATE_TARGET_TAGS_EDITOR_VALIDATION,
        editorId,
        errors
    };
}

export const RESET_TARGET_TAGS_EDITORS = 'RESET_TARGET_TAGS_EDITORS';
export type RESET_TARGET_TAGS_EDITORS = typeof RESET_TARGET_TAGS_EDITORS;

export interface ResetTargetTagsEditorsAction {
    type: RESET_TARGET_TAGS_EDITORS;
    editorIds?: string[];
}

export function resetTargetTagsEditors(editorIds?: string[]): ResetTargetTagsEditorsAction {
    return {
        type: RESET_TARGET_TAGS_EDITORS,
        editorIds
    };
}

export type TargetTagsEditorAction =
    | ChangeTargetPlatformAction
    | InitTargetTagsEditorsAction
    | UpdateTargetTagsEditorValidationAction
    | ResetTargetTagsEditorsAction;
